import { useSelect } from '@wordpress/data';
import React, { useEffect, useState } from 'react';
import { useBlockProps } from '@wordpress/block-editor';
import AddToCalendar from './components/AddToCalendar';
import './editor.scss';

function ordinalSuffix(day) {
	const suffix = (day % 10 === 1 && day % 100 !== 11) ? 'st' :
		(day % 10 === 2 && day % 100 !== 12) ? 'nd' :
			(day % 10 === 3 && day % 100 !== 13) ? 'rd' : 'th';
	return day + suffix;
}

function formatDate(dateStr) {
	if (!dateStr) return '';

	const date = new Date(dateStr);
	const day = date.getDate();
	const month = date.toLocaleString('default', { month: 'long' });
	return `${month} ${ordinalSuffix(day)}`;
}

function formatTime(timeStr) {
	if (!timeStr) return '';

	const date = new Date(`1970-01-01T${timeStr}`);
	return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
}

function formatDateTime(dateStr, timeStr) {
	const formattedDate = formatDate(dateStr);
	const formattedTime = formatTime(timeStr);
	return formattedDate && formattedTime ? `${formattedDate} @ ${formattedTime}` : '';
}

export default function Edit({ attributes, setAttributes }) {
	const currentPostId = useSelect((select) => select('core/editor').getCurrentPostId(), []);
	const [eventData, setEventData] = useState(null);

	useEffect(() => {
		if (!attributes.postId && currentPostId) {
			setAttributes({ postId: currentPostId });
		}

		if (attributes.postId) {
			fetch(`/wp-json/fsdpe/v1/event-meta/${attributes.postId}`)
				.then(response => response.json())
				.then(data => {
					setEventData(data);
				})
				.catch(error => console.error('Error fetching event meta:', error));
		}
	}, [attributes.postId, currentPostId, setAttributes]);

	return (
		<div {...useBlockProps()}>
			{eventData ? (
				<>
					{eventData.event.image && eventData.event.image.trim() !== "" && (
						<div className={'fsdpe-image-wrapper'}>
							<img src={eventData.event.image} alt="Featured image"/>
						</div>
					)}

					{eventData.event.details && eventData.event.details.trim() !== "" && (
						<div>Description: {eventData.event.details}</div>
					)}

					{eventData.event.date && eventData.event.timeStart && (
						<div>{formatDateTime(eventData.event.date, eventData.event.timeStart)}</div>
					)}

					<AddToCalendar event={eventData}/>
				</>
			) : (
				'Loading event data...'
			)}
		</div>
	);
}
